module.exports = __webpack_public_path__ + "static/img/logo-300.709f811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-300.png
// module id = ZiJo
// module chunks = 1